export default "__VITE_ASSET__OCf9lVCC__"